import {
  Box,
  useColorModeValue,
  Text,
  Flex,
  Spinner,
  Center,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { DashReportForm } from './components';
import { useCarriers, useDashReport } from 'hooks/index';
import type { DashReportFormData } from './schemas';

const DashReportView = () => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const { carrierOptions, carriers, isLoadingCarriers, carriersError } =
    useCarriers();

  // Use custom hook for DASH report generation
  const { generateReport } = useDashReport();

  // Handle form submission - PDF downloads automatically
  const handleFormSubmit = async (data: DashReportFormData): Promise<void> => {
    await generateReport(data);
  };

  // Show error if carriers failed to load
  if (carriersError) {
    return (
      <Card>
        <Alert status="error">
          <AlertIcon />
          <AlertDescription>
            Failed to load carriers. Please refresh the page and try again.
          </AlertDescription>
        </Alert>
      </Card>
    );
  }

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      <Flex px="20px" justifyContent="space-between" align="center" mb="20px">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          DASH Report
        </Text>
        <Text fontSize="sm" color="gray.500">
          Generate DASH driver report
        </Text>
      </Flex>

      <Box px="20px" pt="20px" borderTop="1px solid" borderColor={borderColor}>
        {isLoadingCarriers && carriers.length === 0 ? (
          <Center py={10}>
            <Spinner size="sm" color="brand.500" />
          </Center>
        ) : (
          <DashReportForm
            carrierOptions={carrierOptions}
            carriers={carriers}
            isLoadingCarriers={isLoadingCarriers}
            onSubmit={handleFormSubmit}
          />
        )}
      </Box>
    </Card>
  );
};

export default DashReportView;
